import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { store } from '../../../models';
import styles from './timer.module.scss';

const Timer = ({
  id,
  theme,
  duration,
  timeDurationOTP,
  resendButtonId = 'twofaResendBtn',
  format = 'mm:ss',
  wrap = false,
  autoRestart = false,
  resendEnabled,
}) => {
  const [minutes, setMinutes] = useState(Math.floor(duration / 60));
  const [seconds, setSeconds] = useState(Math.floor(duration % 60));

  useEffect(() => {
    if (timeDurationOTP){
      setMinutes(Math.floor(store.getState().settings.timeDurationOTP / 60))
      setSeconds(Math.floor(store.getState().settings.timeDurationOTP % 60))
    }
  }, [timeDurationOTP])

  // resendEnabled flips true -> false only when something explicitly
  // re-disables resendButtonId after this same timer had already enabled it
  // (i.e. a resend click) — the initial pre-dispatch state is undefined, not
  // false, so this can't misfire on mount. Opt-in via autoRestart so the
  // legacy 2FA timer (which restarts itself through timeDurationOTP instead)
  // is unaffected.
  useEffect(() => {
    if (autoRestart && resendEnabled === false) {
      setMinutes(Math.floor(duration / 60));
      setSeconds(Math.floor(duration % 60));
    }
  }, [resendEnabled]);

  useEffect(() => {
    let interval = null;
    if (minutes > 0 || seconds > 0) {
      interval = setInterval(() => {
        if (seconds > 0) setSeconds(seconds - 1);
        else if (minutes > 0) {
          setMinutes(minutes - 1);
          setSeconds(59);
        } else clearInterval(interval);
      }, 1000);
    }
    else {
      store.dispatch.settings.setTimeDuration({duration: 0})
      store.dispatch.button.enableButton({
        btn: resendButtonId,
        complete: true,
      });
    }
    return () => clearInterval(interval);
  }, [minutes, seconds]);

  const display =
    format === 'seconds'
      ? `${minutes * 60 + seconds}s`
      : `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;

  return <h6 id={id} className={classNames(styles.timer, styles[theme])}>{wrap ? `(${display})` : display}</h6>;
};

const mapStateToProps = (state, ownProps) => {
  return {
    timeDurationOTP: state.settings.timeDurationOTP,
    resendEnabled: ownProps.resendButtonId ? state.button[ownProps.resendButtonId] : undefined,
  };
};

export default connect(mapStateToProps, null)(Timer);
